import axios from "axios";

export const createFacility = async (username, locationVOToCreate) => {
    try {
        const {data} = await axios.post("/api/locationLookUp/create", {username, locationVOToCreate});
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const retrieveAllFacilities = async (username) => {
    try {
        const {data} = await axios.get("/api/locationLookUp/viewAll?username=" + username);
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const updateFacility = async (username, locationVOToUpdate) => {
    try {
        const {data} = await axios.put("/api/locationLookUp/update", {username, locationVOToUpdate});
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const deleteFacility = async (username, externalReference) => {
    try {
        const {data} = await axios.delete("/api/locationLookUp/delete", {data: {username, externalReference}});
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const retrieveCountriesForDropdown = async (username) => {
    try {
        const {data} = await axios.get("/api/locationLookUp/viewCountries?username=" + username);
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const retrieveProvincesForDropdown = async (username, country) => {
    try {
        const {data} = await axios.get("/api/locationLookUp/viewProvinces?username=" + username + "&key=" + country);
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const retrieveDistrictsForDropdown = async (username, country, province) => {
    const key = country + "_" + province;
    try {
        const {data} = await axios.get("/api/locationLookUp/viewDistricts?username=" + username + "&key=" + key);
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const retrieveSubDistrictsForDropdown = async (username, country, province, district) => {
    try {
        const key = country + "_" + province + "_" + district;
        const {data} = await axios.get("/api/locationLookUp/viewSubDistricts?username=" + username + "&key=" + key);
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const retrieveFacilitiesForDropdown = async (username, country, province, district, subDistrict) => {
    try {
        const key = country + "_" + province + "_" + district + "_" + subDistrict;
        const {data} = await axios.get("/api/locationLookUp/viewFacilities?username=" + username + "&key=" + key);
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const viewLocation = async (username, locationVOToView) => {
    try {
        const {data} = await axios.post("/api/locationLookUp/view", {username, locationVOToView});
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const findLocationsBasedOnSortOrder = async (username) => {
    try {
        const {data} = await axios.get("/api/locationLookUp/findLocationsBasedOnSortOrder?username=" + username);
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}
